import { render, staticRenderFns } from "./OrderInvoiceCard.html?vue&type=template&id=0d5def52&scoped=true&"
import script from "./OrderInvoiceCard.js?vue&type=script&lang=js&"
export * from "./OrderInvoiceCard.js?vue&type=script&lang=js&"
import style0 from "./OrderInvoiceCard.scss?vue&type=style&index=0&id=0d5def52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5def52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDivider,VIcon,VRow})
